import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AppContext';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_lunch-roster-hub/artifacts/wio7p25o_rr%20logo.png';

const AdminLogin = () => {
  const { loginAdmin, isAdminLoggedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAdminLoggedIn) {
      navigate('/admin/dashboard');
      return;
    }
    (async () => {
      try {
        const result = await loginAdmin();
        if (result.success) {
          navigate('/admin/dashboard');
        }
      } catch (error) {
        console.error('Admin access error:', error);
        toast.error('Could not open the admin panel. Please try again.');
      }
    })();
  }, [isAdminLoggedIn, loginAdmin, navigate]);

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-4" data-testid="admin-login-page">
      <img
        src={LOGO_URL}
        alt="Rolling River Day Camp"
        className="w-24 h-24 object-contain mb-6"
        data-testid="admin-camp-logo"
      />
      <h1 className="text-2xl md:text-3xl font-black text-center text-white mb-2">
        Admin Access
      </h1>
      <p className="text-slate-400 text-center mb-8">Kitchen &amp; Director Portal</p>
      <div className="flex items-center gap-2 text-slate-300" data-testid="admin-auto-login-loading">
        <Loader2 className="w-5 h-5 animate-spin" />
        Opening admin panel...
      </div>
    </div>
  );
};

export default AdminLogin;
